import type ColorScheme from '../ColorScheme';
import getComposeOptimalColorStrings from './getComposeOptimalColorStrings';

/**
 * This function override theme colors based on optimal calendar colors.
 * @param colorScheme - calendar color Scheme
 */
export default function generateCssVariablesForCompose(colorScheme: ColorScheme) {
    let colorStrings: ColorScheme = getComposeOptimalColorStrings(colorScheme);

    if (colorStrings) {
        return {
            ['--themePrimary']: colorStrings.calPrimary,
            ['--themeLight']: colorStrings.calLight,
            ['--themeDark']: colorStrings.calDark,
            ['--themeDarkAlt']: colorStrings.calDark,
            ['--themeDarker']: colorStrings.calDarker,
            ['--themeSecondary']: colorStrings.calSecondary,
            ['--themeTertiary']: colorStrings.calTertiary,
            ['--themeLighter']: colorStrings.calLighter,
            ['--themeLighterAlt']: colorStrings.calLighterAlt,
        };
    }
    return null;
}
